import React from "react";
import {
  CheckboxRow,
  CheckboxLabel,
  StyledCheckbox,
  CheckboxLink,
} from "./Checkbox.elements";

export type CheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  label?: React.ReactNode;
};

export default function Checkbox({ id, checked, onChange, required, label }: CheckboxProps) {
  return (
    <CheckboxRow>
      <StyledCheckbox
        id={id}
        checked={checked}
        onChange={onChange}
        required={required}
      />
      <CheckboxLabel htmlFor={id}>{label}</CheckboxLabel>
    </CheckboxRow>
  );
}

export { CheckboxLink };
